import script from "./DisplayCurriculumHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./DisplayCurriculumHeader.vue?vue&type=script&setup=true&lang=js"

import "./DisplayCurriculumHeader.vue?vue&type=style&index=0&id=5e855842&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e855842"]])

export default __exports__